module.exports = __webpack_public_path__ + "img/iOS.28dd6502.png";